// extracted by mini-css-extract-plugin
export var container = "AboutTeamMemberLinkTemplate-module--container--N5hCq";
export var photo = "AboutTeamMemberLinkTemplate-module--photo--hDk7h";
export var name = "AboutTeamMemberLinkTemplate-module--name--TMQxg";